import doRequest from "./apiRequestor";

const fetchGlobalSettings = async (idToken, setGlobalSettings) =>  {
    let globalSettings = await doRequest("/api/GlobalSettings", idToken);
    setGlobalSettings(globalSettings);
    return globalSettings;
}

export default fetchGlobalSettings